import { render, staticRenderFns } from "./returnMoney.vue?vue&type=template&id=3e0af0c5&scoped=true"
import script from "./returnMoney.vue?vue&type=script&lang=js"
export * from "./returnMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0af0c5",
  null
  
)

export default component.exports